import { render, staticRenderFns } from "./BaseDelete.vue?vue&type=template&id=1a1d1277&"
import script from "./BaseDelete.vue?vue&type=script&lang=js&"
export * from "./BaseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports